// src\services\locales\plano.js
import AuthService from "@/services/auth/auth.js";

export default {
  /**
   * Obtiene la estructura base del plano: imagen, dimensiones y posiciones iniciales.
   */
  async obtenerPlanoBase(localId) {
    // Usamos authenticatedRequest que ya maneja la URL base y los tokens
    return await AuthService.authenticatedRequest(`/locales/api/local/${localId}/plano/`);
  },

  /**
   * Obtiene los datos de las vistas (disponibilidad o temperatura_equipo).
   */
  async obtenerDatosVista(localId, vista) {
    return await AuthService.authenticatedRequest(`/locales/api/local/${localId}/plano/datos?vista=${vista}`);
  },

  /**
   * Guarda todo el layout completo después de hacer drag and drop.
   */
  async guardarPosiciones(localId, posicionesFrontend) {
    const payload = {
      posiciones: posicionesFrontend.map((pos) => ({
        dispositivo_id: pos.dispositivo.id,
        fila: pos.fila,
        columna: pos.columna,
      })),
    };

    // Para enviar datos (PATCH/POST), AuthService recibe un segundo parámetro con la configuración
    return await AuthService.authenticatedRequest(`/locales/api/local/${localId}/plano/posiciones/`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  },
  /**
   * Obtiene todos los dispositivos que pertenecen a un local.
   * Útil para poblar el plano cuando está recién creado y no hay posiciones guardadas.
   */
  async obtenerDispositivos(localId) {
    return await AuthService.authenticatedRequest(`/locales/api/local/${localId}/DispositivosLocal/`);
  },
};
